import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import GlobalVariable from "../../../services/globalVar.js";
import * as XLSX from "xlsx";

const SalesByCust = (props) => {
    const parentDatas = props;
    const currency = GlobalVariable.userDet.tenantConfig.currency;

    const exportExcel = () => {
        const worksheetData = parentDatas.saleByCust.map((row) => ({
            "Customer Name": row.customerName,
            "Invoice Count": row.invoiceCount,
            "Sales Amount": row.salesAmount?.toFixed(2),
            "Sales with Tax": row.salesWithTax?.toFixed(2),
        }));

        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new(); 
        XLSX.utils.book_append_sheet(workbook, worksheet, "SalesByCustomer");
        XLSX.writeFile(workbook, "Sales_By_Customer.xlsx");
    };

    const customerNameBodyTemplate = (rowData) => (
        <div className="customer-name-wrapper">
            <div className="customer-avatar">
                {rowData.customerName?.charAt(0)?.toUpperCase() || "C"}
            </div>
            <div className="customer-details">
                <span className="customer-name">{rowData.customerName}</span>
            </div>
        </div>
    );

    const invoiceCountBodyTemplate = (rowData) => (
        <div className="invoice-count-wrapper">
            <span className="">{rowData.invoiceCount}</span>
        </div>
    );

    const salesAmountBodyTemplate = (row) => (
        <div className="amount-wrapper">
            <span className="currency-symbol">{currency}</span>
            <span className="amount-value">{row?.salesAmount?.toFixed(2)}</span>
        </div>
    );

    const salesWithTaxBodyTemplate = (row) => (
        <div className="amount-wrapper sales-with-tax">
            <span className="currency-symbol">{currency}</span>
            <span className="amount-value">{row?.salesWithTax?.toFixed(2)}</span>
        </div>
    );

    return (
        <>
            <div className="bg-white shadow-sm chart-of-account h-100 cc-greyCard-custm1 enhanced-sales-container">
                <div className="row coa-header kk-header-sec p-2">
                    <div className="col-6">
                        <div className="header-content">
                            <div className="header-title">
                                <div className="section-title">
                                    <i className="pi pi-users header-icon"></i>
                                    Sales by Customer 
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="col-6 text-end d-flex justify-content-end align-items-center">
                       
                        <button className="btn btn-primary" onClick={exportExcel}>
                            <i className="pi pi-download"></i> Download 
                        </button>
                    </div>
                </div>

                <div className="account-table enhanced-table-wrapper">
                    <DataTable
                        stripedRows
                        showGridlines
                        tableStyle={{ minWidth: "100%" }}
                        className="enhanced-datatable"
                        paginator
                        rows={10}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        paginatorLeft={
                            <div className="paginator-info">
                                <span>
                                    Total Records:{" "}
                                    {parentDatas.saleByCust?.length || 0}
                                </span>
                            </div>
                        }
                        value={parentDatas.saleByCust}
                        expandedRows={parentDatas.expandedRows}
                        onRowToggle={(e) => parentDatas.setExpandedRows(e.data)}
                        rowExpansionTemplate={
                            parentDatas.rowExpansionTemplate
                        }
                        emptyMessage={
                            <div className="empty-state">
                                <i className="pi pi-inbox empty-icon"></i>
                                <h5>No data available</h5>
                                <p>
                                    There are no customer sales records to
                                    display
                                </p>
                            </div>
                        }
                        responsiveLayout="scroll"
                    >
                        <Column
                            expander={parentDatas.allowExpansion}
                            style={{ width: "4rem" }}
                            headerStyle={{ background: "#f8f9fa" }}
                        />

                        <Column
                            field="customerName"
                            header={<div className="column-header">Customer Name</div>}
                            style={{ width: "35%", minWidth: "250px" }}
                            body={customerNameBodyTemplate}
                            headerStyle={{
                                background: "#f8f9fa",
                                fontWeight: "600",
                            }}
                            sortable
                        />

                        <Column
                            field="invoiceCount"
                            header={<div className="column-header">Invoice Count</div>}
                            style={{ width: "20%", textAlign: "center" }}
                            body={invoiceCountBodyTemplate}
                            headerStyle={{
                                background: "#f8f9fa",
                                fontWeight: "600",
                                textAlign: "center",
                            }}
                            sortable
                        />

                        <Column
                            field="salesAmount"
                            header={<div className="column-header">Sales Amount</div>}
                            className="text-end amount-align"
                            style={{ width: "22.5%" }}
                            body={salesAmountBodyTemplate}
                            headerStyle={{
                                background: "#f8f9fa",
                                fontWeight: "600",
                                textAlign: "right",
                            }}
                            sortable
                        />

                        <Column
                            field="salesWithTax"
                            header={<div className="column-header">Sales with Tax</div>}
                            className="text-end amount-align"
                            style={{ width: "22.5%" }}
                            body={salesWithTaxBodyTemplate}
                            headerStyle={{
                                background: "#f8f9fa",
                                fontWeight: "600",
                                textAlign: "right",
                            }}
                            sortable
                        />
                    </DataTable>
                </div>



                <style jsx>{`
                    .enhanced-sales-container {
                        border-radius: 12px;
                        overflow: hidden;
                        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
                        border: 1px solid #e5e7eb;
                    }

                    .enhanced-header {
                        background: linear-gradient(115deg, rgba(87, 199, 133, 1) 0%,  rgba(42, 123, 155, 1) 100%);
                        color: white;
                        padding: 0.5rem 0;
                        margin: 0;
                    }

                    .header-content {
                        padding: 0 1.5rem;
                    }

                    .section-title {
                        margin: 0;
                        font-size: 1.5rem;
                        font-weight: 600;
                        display: flex;
                        align-items: center;
                        gap: 0.75rem;
                    }

                    .section-subtitle {
                        margin: 0.25rem 0 0 0;
                        opacity: 0.9;
                        font-size: 0.95rem;
                        font-weight: 400;
                    }

                    .header-icon {
                        font-size: 1.25rem;
                        opacity: 0.9;
                    }

                    .enhanced-table-wrapper {
                        padding: 0;
                    }

                    .enhanced-datatable {
                        border: none !important;
                    }

                    .enhanced-datatable .p-datatable-header {
                        background: #f8f9fa;
                        border: none;
                        padding: 1rem 1.5rem;
                        font-weight: 600;
                    }

                    .enhanced-datatable .p-datatable-tbody > tr {
                        transition: all 0.2s ease;
                    }

                    .enhanced-datatable .p-datatable-tbody > tr:hover {
                        background: #f8f9fa !important;
                        transform: translateY(-1px);
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    }

                    .enhanced-datatable .p-datatable-tbody > tr > td {
                        padding: 1rem 1.5rem;
                        border-bottom: 1px solid #f1f3f4;
                        vertical-align: middle;
                    }

                    .column-header {
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                        color: #374151;
                    }

                    .column-header .header-icon {
                        font-size: 0.9rem;
                        color: #6b7280;
                    }

                    .customer-name-wrapper {
                        display: flex;
                        align-items: center;
                        gap: 0.75rem;
                    }

                    .customer-avatar {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        background: linear-gradient(90deg, rgba(87, 199, 133, 1) 0%,  rgba(42, 123, 155, 1) 100%);

                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: white;
                        font-weight: 600;
                        font-size: 0.9rem;
                        flex-shrink: 0;
                    }

                    .customer-details {
                        display: flex;
                        flex-direction: column;
                    }

                    .customer-name {
                        font-weight: 500;
                        color: #1f2937;
                        font-size: 0.95rem;
                    }

                    .invoice-count-wrapper {
                        display: flex;
                        justify-content: center;
                    }

                    .count-badge {
                        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
                        color: white;
                        padding: 0.375rem 0.75rem;
                        border-radius: 20px;
                        font-weight: 600;
                        font-size: 0.875rem;
                        min-width: 40px;
                        text-align: center;
                        box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
                    }

                    .amount-wrapper {
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        gap: 0.25rem;
                        font-family: 'Segoe UI', 'SF Pro Display', system-ui, sans-serif;
                        font-weight: 500;
                    }

                    .currency-symbol {
                        color: #6b7280;
                        font-size: 0.9rem;
                        font-weight: 500;
                    }

                    .amount-value {
                        color: #1f2937;
                        font-size: 1rem;
                        font-weight: 600;
                        font-variant-numeric: tabular-nums;
                    }

                    .sales-with-tax .amount-value {
                        color: #059669;
                    }

                    .empty-state {
                        text-align: center;
                        padding: 3rem 2rem;
                        color: #6b7280;
                    }

                    .empty-icon {
                        font-size: 3rem;
                        color: #d1d5db;
                        margin-bottom: 1rem;
                    }

                    .empty-state h5 {
                        color: #374151;
                        margin-bottom: 0.5rem;
                        font-weight: 600;
                    }

                    .empty-state p {
                        margin: 0;
                        font-size: 0.9rem;
                    }

                    .enhanced-datatable .p-paginator {
                        background: #f9fafb;
                        border: none;
                        border-top: 1px solid #e5e7eb;
                        padding: 1rem 1.5rem;
                    }

                    .enhanced-datatable .p-paginator .p-paginator-pages .p-paginator-page {
                        border-radius: 6px;
                        margin: 0 2px;
                    }

                    .enhanced-datatable .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
                        background: #667eea;
                        border-color: #667eea;
                    }

                    .paginator-info {
                        display: flex;
                        align-items: center;
                        color: #6b7280;
                        font-weight: 500;
                        font-size: 0.9rem;
                    }

                    .enhanced-datatable .p-paginator .p-dropdown {
                        margin-right: 0.5rem;
                    }

                    .enhanced-datatable .p-paginator .p-paginator-current {
                        background: transparent;
                        color: #374151;
                        font-weight: 500;
                    }

                    .enhanced-datatable .p-row-expansion {
                        background: #f8f9fa;
                        border-left: 4px solid #667eea;
                    }

                    @media (max-width: 768px) {
                        .enhanced-header {
                            padding: 1rem 0;
                        }

                        .header-content {
                            padding: 0 1rem;
                        }

                        .section-title {
                            font-size: 1.25rem;
                        }

                        .enhanced-datatable .p-datatable-tbody > tr > td {
                            padding: 0.75rem 1rem;
                        }

                        .customer-avatar {
                            width: 35px;
                            height: 35px;
                            font-size: 0.8rem;
                        }

                        .customer-name-wrapper {
                            gap: 0.5rem;
                        }

                        .amount-wrapper {
                            flex-direction: column;
                            gap: 0;
                            align-items: flex-end;
                        }
                    }

                    @media (max-width: 576px) {
                        .column-header {
                            font-size: 0.85rem;
                        }

                        .customer-name {
                            font-size: 0.85rem;
                        }

                        .amount-value {
                            font-size: 0.9rem;
                        }

                        .count-badge {
                            font-size: 0.8rem;
                            padding: 0.25rem 0.5rem;
                        }
                    }
                `}</style>
            </div>
        </>
    )
}

export default SalesByCust